<template>
  <a-modal
    v-model:open="showModal"
    :footer="null"
    destroyOnClose
    title="Выберите принтер"
    width="fit-content"
    centered
    @cancel="onClose"
  >
    <a-flex vertical gap="small" align="center" justify="center">
      <a-button
        v-for="(printerName, index) in printers"
        :key="index"
        @click="printerSelected(printerName)"
      >
        {{ printerName }}
      </a-button>
    </a-flex>
  </a-modal>
</template>

<script setup lang="ts">
import { useQzTrayStore } from "@/stores/qzTray/qzTrayStore";
import { computed, ref } from "vue";

const emit = defineEmits<{
  (e: "printerSelected", printerName: string): void;
  (e: "close"): void;
}>();

const qzTrayStore = useQzTrayStore();
const showModal = ref(true);
const printers = computed(() => qzTrayStore.printers);

const printerSelected = (printerName: string) => {
  emit("printerSelected", printerName);
  showModal.value = false;
};

const onClose = () => {
  emit("close");
};
</script>

<style scoped lang="scss"></style>
